import React, { useEffect } from 'react'
import gsap from 'gsap';
import '../scss/toast.scss'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';

export const Toast =({status, message, onClose}: { status: 'success' | 'error' | 'warning' | 'info', message: string, onClose: () => void}) => {

  const mapping = {
    success: {
      color: '#49A255',
      icon: <CheckCircleIcon/>
    },
    error: {
      color: '#C84243',
      icon: <ErrorIcon/>
    },
    warning: {
      color: '#E0954B',
      icon: <CancelIcon/>
    },
    info: {
      color:'#3DAAC6',
      icon: <InfoIcon/>
    },
  }
  setTimeout(()=>{
    onClose()
  }, 5000)

  useEffect(()=> {
    const div = document.getElementById('toast');
    gsap.to(div , {
      duration:0,
      opacity:0
    });
    gsap.to(div , {
        duration:1,
        opacity:1
    }).delay(0.1);
  },[])

  return (
    <div id='toast' style={{background: mapping[status].color}}>
      <div className='toast__wrapper'>
        <div className='toast__close' onClick={()=>{
          onClose()
        }}><CloseIcon/></div>
        <div className='toast__images'>
          {mapping[status].icon}
        </div>
        <div className='toast__content'>
          <div className='toast__title'>{status}</div>
          <div className='toast__message'>{message}</div>
        </div>
      </div>
    </div>
  )
}
